window.hamburgerInProgress = false;

$('.js-hamburger').click(function(e){

    if(!window.hamburgerInProgress) {
     
      window.hamburgerInProgress = true;

      if($('.js-hamburger').attr('aria-expanded') == 'true') {
        
        $('.js-hamburger').removeClass('is-active');
        
        $('#meganav').collapse('hide');
        $('body').removeClass('nav-active');

      } else {

        $('.js-hamburger').addClass('is-active');

        $('#meganav').collapse('show');
        $('body').addClass('nav-active');

      }

      setTimeout(() => {

        window.hamburgerInProgress = false;

      }, 1000);

    }

    e.preventDefault();
    return;

});

$('.nav-link.dropdown-toggle').click((e) => {

  if($(e.currentTarget).attr('data-toggle') == 'dropdown' && $(e.target).is('span')) {

    $(e.currentTarget).trigger('click');

    window.location = $(e.currentTarget).attr('href');

    e.preventDefault();
    return;

  }

});

$(document).on('click', 'header .nav.navbar-toolbar .dropdown-menu', function (e) {
  e.stopPropagation();
});